import PropTypes from "prop-types";
import classNames from "classnames";

import { numberSeparator, contains } from "utils";
import { calcGainPercentage } from "features/Strategy/utils";
import { unixToDateTime, DATE_FORMAT } from "utils/date";

export const ChartTooltip = ({
  active = false,
  payload = [],
  activePeriod,
}) => {
  if (active && payload && payload.length) {
    const period = activePeriod?.toLowerCase();
    let datetime = unixToDateTime(payload[0].payload.name, DATE_FORMAT);

    if (period === "1w" || period === "1m") {
      datetime = unixToDateTime(payload[0].payload.name);
    }
    return (
      <div className="chart-tooltip">
        <span className="hp-datetime">{datetime}</span>
      </div>
    );
  }

  return null;
};

ChartTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array,
  activePeriod: PropTypes.string,
};

export const ChartTooltipWithProfit = ({
  active = false,
  payload = [],
  firstValue = 0,
}) => {
  if (active && payload && payload.length) {
    return (
      <div className="chart-tooltip">
        {!payload[0].payload.hideTimestamp && (
          <span className="datetime">
            {unixToDateTime(payload[0].payload.name, DATE_FORMAT)}
          </span>
        )}

        {payload.map((p, i) => {
          const value = p.value;
          const gain = p.value - firstValue;

          const gainPercentage = calcGainPercentage(firstValue, value);
          const formattedGainPercentage = gainPercentage
            ? numberSeparator(gainPercentage)?.replace("-", "")
            : gainPercentage;

          const formattedGain = gain
            ? numberSeparator(gain)?.replace("-", "")
            : gain;

          const isStrategyValue = contains(p.name, "Strategy");

          return (
            <div key={i} className="label" style={{ color: p.color }}>
              {/* Label */}
              <span
                className={classNames({
                  gain: isStrategyValue && value >= firstValue,
                  loss: isStrategyValue && value < firstValue,
                })}
              >
                {p.payload.label || p.name}{" "}
              </span>
              {/* Value */}
              <span
                className={classNames({
                  gain: isStrategyValue && value >= firstValue,
                  loss: isStrategyValue && value < firstValue,
                })}
              >
                {value >= firstValue ? "+" : "-"}${formattedGain} (
                {value >= firstValue ? "+" : "-"}
                {formattedGainPercentage}%)
              </span>
            </div>
          );
        })}
      </div>
    );
  }

  return null;
};

ChartTooltipWithProfit.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array,
  firstValue: PropTypes.number,
};
